module.exports = __webpack_public_path__ + "img/isuzu.86922070.jpeg";